"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenAIModel = exports.OpenAIKey = exports.OpenAIConnector = void 0;
exports.textToSql = textToSql;
exports.sqlToText = sqlToText;
exports.updateSql = updateSql;
exports.fixSql = fixSql;
exports.optimizeSql = optimizeSql;
exports.explainQueryPlan = explainQueryPlan;
const llmUtils_1 = require("./llmUtils");
// gpt-3.5-turbo: context window: 16k tokens
// gpt-4-turbo: context window: 128k tokens
// 1 token ~ 4 chars: https://platform.openai.com/tokenizer
var openai_1 = require("./openai");
Object.defineProperty(exports, "OpenAIConnector", { enumerable: true, get: function () { return openai_1.OpenAIConnector; } });
Object.defineProperty(exports, "OpenAIKey", { enumerable: true, get: function () { return openai_1.OpenAIKey; } });
Object.defineProperty(exports, "OpenAIModel", { enumerable: true, get: function () { return openai_1.OpenAIModel; } });
// TODO: suggest schema improvements: design, perf
async function textToSql(llm, dialect, userPrompt, db) {
    // https://docs.anthropic.com/en/prompt-library/sql-sorcerer
    // https://dev.to/datalynx/llms-for-text-to-sql-problems-the-benchmark-vs-real-world-performance-2064
    // if db too big (>100 tables), select relevant tables with a prompt
    // hint with tables on the current layout?
    const systemPrompt = 'You are a pragmatic data analyst focusing on query performance and correctness.\n' +
        `Here is the database you have at your disposal:\n${(0, llmUtils_1.dbToPrompt)(db)}\n` +
        `Answer the user request generating only one valid SQL query using ${dialect} dialect and formatted nicely, no other text at all, this is very important.`;
    const answer = await llm.query(systemPrompt, userPrompt);
    return (0, llmUtils_1.cleanSqlAnswer)(answer);
}
async function sqlToText(llm, sqlQuery) {
    // TODO: ask for name, description and explanation of the query
    const systemPrompt = 'You are an experimented data analyst.\n' +
        'The user will with you an SQL query and you will explain it how it works.\n' +
        'Answer in a clear and concise way, not extra explanation not linked to the query.';
    return await llm.query(systemPrompt, sqlQuery);
}
async function updateSql(llm, dialect, sqlQuery, userPrompt, db) {
    // TODO: update SQL with english prompt
    return Promise.reject('Not implemented');
}
async function fixSql(llm, dialect, sqlQuery, error, db) {
    // TODO: fix SQL query when it doesn't work
    return Promise.reject('Not implemented');
}
async function optimizeSql(llm, dialect, sqlQuery, db) {
    // TODO: rewrite query for better performance, provide indexes & query plan => challenge, make it clear when not possible!
    return Promise.reject('Not implemented');
}
async function explainQueryPlan(llm, dialect, sqlQuery, queryPlan) {
    // TODO: explain query plan
    return Promise.reject('Not implemented');
}
// TODO: suggest tables for a specific topic (build layout)
// TODO: chat with your db
// TODO: suggest schema changes for a new feature
// TODO: function calling to interact with Azimutt (ex: "Show all the tables related to projects")
// TODO: detect PII, https://docs.anthropic.com/en/prompt-library/pii-purifier
//# sourceMappingURL=index.js.map